import React from 'react';
import PropTypes from 'prop-types';
import ClickLink from 'App/components/styles/ClickLink';

const propTypes = {
    canEnrollPatientMessaging: PropTypes.bool,
    showMessagingModal: PropTypes.func.isRequired,
};

const defaultProps = {
    canEnrollPatientMessaging: true,
};

function NoSubmission({ canEnrollPatientMessaging, showMessagingModal }) {
    return (
        <div style={{ flexGrow: 1, flexBasis: '50%' }}>
            {canEnrollPatientMessaging ? (
                <ClickLink onClick={showMessagingModal}>Enroll Patient</ClickLink>
            ) : (
                <span>
                    <i className="fas fa-fw fa-info-circle text-info" />
                    Patient&apos;s branch is not configured for mobile messaging.
                </span>
            )}
        </div>
    );
}

NoSubmission.propTypes = propTypes;
NoSubmission.defaultProps = defaultProps;

export default NoSubmission;
